module.exports = require('./lib');


//////////////////
// WEBPACK FOOTER
// ./~/react-highlight/index.js
// module id = 927
// module chunks = 0